var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 0C11.7 0 0.5 11.2 0.5 25C0.5 38.8 11.7 50 25.5 50C39.3 50 50.5 38.8 50.5 25C50.5 11.2 39.3 0 25.5 0ZM25.5 45C14.475 45 5.5 36.025 5.5 25C5.5 13.975 14.475 5 25.5 5C36.525 5 45.5 13.975 45.5 25C45.5 36.025 36.525 45 25.5 45ZM20.5 30.425L36.975 13.95L40.5 17.5L20.5 37.5L10.5 27.5L14.025 23.975L20.5 30.425Z",
    fill: "url(#paint0_linear_1565_11421)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1565_11421",
    x1: 54.8525,
    y1: 9.13798,
    x2: 24.1379,
    y2: 65.5441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0981253,
    stopColor: "#B6D45B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607067,
    stopColor: "#88C139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910011,
    stopColor: "#73A533"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBig);
export default __webpack_public_path__ + "static/media/check-circle-big.b60e3ae352ec7b6fb1b6cab70961e2ef.svg";
export { ForwardRef as ReactComponent };